import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forest',
  templateUrl: './forest.component.html',
  styleUrls: ['./forest.component.scss']
})
export class ForestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
